import {$authHost, $host} from ".";

export const getShopStore = async () => {
    const {data} = await $authHost.get('api/v1/getShopStore.php', {},{withCredentials: true});
    return data;
};

export const walletHistory = async () => {
    const {data} = await $authHost.get('api/v1/walletHistory.php', {},{withCredentials: true});
    return data;
};

export const createPayment = async (amount, methodId) => {
    const {data} = await $authHost.post('api/v1/createPayment.php', {
        amount: amount,
        method_id: methodId
    }, {withCredentials: true});
    return data;
};

export const purchaseShopItem = async (serverId, itemId) => {
    const { data } = await $authHost.post(
        'api/v1/purchaseShopItem.php', // Замените на ваш реальный эндпоинт
        {
            server_id: serverId,
            item_id: itemId
        },
        { withCredentials: true }
    );
    return data;
};

export const getPaymentMethods = async () => {
    const {data} = await $authHost.get('api/v1/paymentMethods.php', {}, {withCredentials: true});
    return data;
};

export const createStoreCategory = async (store_name) => {
    const {data} = await $authHost.post('api/v1/createStoreCategory.php', {store_name},{withCredentials: true});
    return data;
};

export const createStoreItem = async (form) => {
    const formData = new FormData();

    // Примитивы
    formData.append("name", form.name);
    formData.append("game_code", form.game_code);
    formData.append("description", form.description);
    formData.append("base_price", form.base_price);
    formData.append("category_id", form.category_id);

    // Проверим, передаётся ли файл или URL
    if (form.image_file) {
        formData.append("image_file", form.image_file);
    } else if (form.image_url) {
        formData.append("image_url", form.image_url);
    }

    const { data } = await $authHost.post(
        "api/v1/createStoreItem.php",
        formData,
        {
            withCredentials: true,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }
    );

    return data;
};

export const editStoreItem = async (form) => {
    const formData = new FormData();

    // Примитивы
    formData.append("id", form.id);
    formData.append("name", form.name);
    formData.append("game_code", form.game_code);
    formData.append("description", form.description);
    formData.append("base_price", form.base_price);
    formData.append("category_id", form.category_id);

    // Проверим, передаётся ли файл или URL
    if (form.image_file) {
        formData.append("image_file", form.image_file);
    } else if (form.image_url) {
        formData.append("image_url", form.image_url);
    }

    const { data } = await $authHost.post(
        "api/v1/editStoreItem.php",
        formData,
        {
            withCredentials: true,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }
    );

    return data;
};
/*
createServerStoreItem,
    editServerStoreItem,
    getServerStoreItems,
    deleteServerStoreItem
 */

export const createServerStoreItem = async (form) => {
    const {data} = await $authHost.post('api/v1/createServerStoreItem.php', {form},{withCredentials: true});
    return data;
};

export const editServerStoreItem = async (form) => {
    const {data} = await $authHost.post('api/v1/editServerStoreItem.php', {form},{withCredentials: true});
    return data;
};

export const getServerStoreItems = async (serverId) => {
    const {data} = await $authHost.post('api/v1/getServerStoreItems.php', {serverId},{withCredentials: true});
    return data;
};

export const sortServerStoreItems = async (serverId, itemId, sort) => {
    const {data} = await $authHost.post('api/v1/sortServerStoreItems.php', {serverId, itemId, sort},{withCredentials: true});
    return data;
};

export const deleteServerStoreItem = async (serverId) => {
    const {data} = await $authHost.post('api/v1/deleteServerStoreItem.php', {serverId},{withCredentials: true});
    return data;
};

export const editStoreCategory = async (id, store_name) => {
    const {data} = await $authHost.post('api/v1/editStoreCategory.php', {id, store_name},{withCredentials: true});
    return data;
};

export const deleteStoreItem = async (id) => {
    const {data} = await $authHost.post('api/v1/deleteStoreItem.php', {id},{withCredentials: true});
    return data;
};